import { withInstall } from '../utils/index';
import MusicPlayer from './index.vue';
import './index.less';

export const TlbsMusicPlayer = withInstall(MusicPlayer);
export default TlbsMusicPlayer;
